




































































































































































































import { Component, Emit, Vue, Watch } from 'vue-property-decorator'
import { Auth } from '@finx/web-repository/src/services/Oidc'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'
import SolicitacaoPendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import { DateTime } from 'luxon'
import { Laudo, Snackbar } from '@/types/_'
import Theme from '@/styles/Theme'
import moment from 'moment'
import EventBus from '@/plugins/EventBus'
import { bytesToMegabytes } from '@/utils/common'
import SolicitacaoClinicaStore from './store/SolicitacaoClinicaStore'

@Component
export default class ComponentModalSolicitacaoCirurgiaItensAutorizadosClinica extends Vue {
  $refs: {
    form: any,
    autorizacaoValidade: any,
  }

  fileUploadLimitInMegaBytes = 25
  isUploadRecommendationModalOpen = false

  closeButton: boolean = false

  isFormValid = true
  autorizacaoValidade = ''
  autorizacaoValidadeText = ''
  autorizacaoValidadeRules = [
    v => !!v || 'Campo obrigatório',
  ]

  anexosOperadora: AnexoOperadora[] = []
  anexosToUpload: ((resolve: any, reject: any) => {})[] = []
  anexosToDelete: ((resolve: any, reject: any) => {})[] = []

  get closeBtn() {
    return this.closeButton
  }

  set closeBtn(value: boolean) {
    this.closeButton = value
  }

  snackbar: Snackbar = {
    disabled: false,
    disabledBtn: false,
    show: false,
    timeout: 12000,
    message: '',
  }

  async salvar() {
    this.$refs.form.validate()
    if (!this.isFormValid) {
      const formErrors = this.$refs.form.errorBag
      const errorsLength = Object.values(formErrors).filter(e => e === true).length
      EventBus.$emit('setSnackbar', { show: true, text: `Foram encontrados ${errorsLength} erro(s) no formulário.`, icon: 'warning', color: '#C62828' })
      return
    }

    const { status, init } = this.solicitacaoStore.requestMessage
    this.setLoadingRequest(status, init.text)

    // Antes de salvar insere e deleta os anexos caso necessário
    const anexoRes = this.updateAnexos()
    if (!anexoRes) {
      this.clearLoadingRequest()
      return
    }

    const data = {
      solicitacaoId: this.solicitacao.id,
      data: {
        autorizacaoValidade: DateTime.fromISO(this.autorizacaoValidade).setZone('America/Sao_Paulo').toISO(),
        autorizacaoObservacao: this.solicitacao.autorizacaoObservacao,
      },
    }

    const res = await this.solicitacaoClinicaStore.atualizarAutorizacao(data)

    if (res.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Autorização salva com sucesso.', icon: 'done', color: '#2E7D32' })

      this.solicitacao.autorizacaoValidade = this.autorizacaoValidade
      this.closeModal()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Houve um erro ao salvar a autorização.', icon: 'warning', color: '#C62828' })
    }

    this.clearLoadingRequest()
  }

  async updateAnexos(): Promise<boolean> {
    if (this.anexosToUpload.length > 0) {
      try {
        const promises = this.anexosToUpload.map(fn => new Promise<any>(fn))
        await Promise.all(promises)
        this.anexosToUpload = []
      } catch (err) {
        return false
      }
    }

    if (this.anexosToDelete.length > 0) {
      try {
        const promises = this.anexosToDelete.map(fn => new Promise<any>(fn))
        await Promise.all(promises)
        this.anexosToDelete = []
      } catch (err) {
        return false
      }
    }

    return true
  }

  async inputFile(file: any) {
    // Check file was exceeded the limit
    const fileSizeInMegabytes = bytesToMegabytes(file.file.size)
    if (fileSizeInMegabytes > this.fileUploadLimitInMegaBytes) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao carregar arquivo. Limite máximo excedido.', icon: 'warning', color: '#C62828' })
      this.openUploadRecommendationModal(500)
      return
    }
    const temporaryAnexoOperadora = { name: file.name, queueIndex: this.anexosToUpload.length } as AnexoOperadora
    this.anexosOperadora.push(temporaryAnexoOperadora)

    const promiseCallback = async (resolve: any, reject: any) => {
      const formData = new FormData()
      formData.append('laudos', file.file)

      const data = {
        solicitacaoId: this.solicitacao.id,
        data: {
          formData,
        },
      }

      const request = await this.solicitacaoClinicaStore.uploadAnexoOperadora(data)

      if ((request.data && request.data.length === 0) || !request.data) {
        const message = request.error || 'Erro ao carregar arquivo. Tente novamente.'
        EventBus.$emit('setSnackbar', { show: true, text: message, icon: 'warning', color: '#C62828' })
        reject()
      }

      resolve(request.data)
    }

    this.anexosToUpload.push(promiseCallback)
  }

  async deleteAnexo(data: AnexoOperadora, index: number) {
    this.anexosOperadora.splice(index, 1)

    if (!data.identifier) {
      this.anexosToUpload.splice(data.queueIndex!, 1)
      return
    }

    const promiseCallback = async (resolve: any, reject: any) => {
      const res = await this.solicitacaoStore.deleteLaudo({
        hospitalId: this.solicitacao.hospitalId,
        id: data.identifier,
      })

      if (!res.success) {
        const message = res.error || 'Erro ao deletar arquivo. Tente novamente.'
        EventBus.$emit('setSnackbar', { show: true, text: message, icon: 'warning', color: '#C62828' })
        reject()
      }

      resolve(res.data)
    }

    this.anexosToDelete.push(promiseCallback)
  }

  openUploadRecommendationModal(delay = 0) {
    setTimeout(() => {
      this.isUploadRecommendationModalOpen = true
    }, delay)
  }

  closeUploadRecommendationModal() {
    this.isUploadRecommendationModalOpen = false
  }

  clickAutorizacaoValidade(event) {
    if (!this.autorizacaoValidade) {
      this.autorizacaoValidade = moment(new Date()).format('YYYY-MM-DDT12:00')
    }

    this.$refs.autorizacaoValidade.open(event)
  }

  clearDate(elements: string[]) {
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i]
      this[element] = ''
    }
  }

  get getAutorizacaoValidadeText() {
    this.autorizacaoValidadeText = this.formatISOToDate(this.autorizacaoValidade)
    return this.autorizacaoValidadeText
  }

  set getAutorizacaoValidadeText(value: string | Date) {
    this.autorizacaoValidadeText = this.formatISOToDate(this.autorizacaoValidade)
  }

  formatISOToDate(value: string | Date) {
    if (value === '') return value
    return DateTime.fromISO(value).toLocaleString(DateTime.DATETIME_MED)
  }

  get solicitacao() { return this.getPendenciaStore.agendamentoMedico }

  get solicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get solicitacaoClinicaStore() {
    return getModule(SolicitacaoClinicaStore, this.$store)
  }

  get getPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get showItensAutorizadosClinica() {
    return this.solicitacaoStore.modalSolicitacaoCirurgia
      .showItensAutorizadosClinica
  }

  set showItensAutorizadosClinica(value: boolean) {
    this.solicitacaoStore.setShowModalItensAutorizadosClinica(value)
  }

  formatDate(value: string) {
    return moment(value).format('DD/MM/YYYY')
  }

  async closeModal() {
    this.closeBtn = true
    this.showItensAutorizadosClinica = false
    this.closeBtn = false
  }

  snackBarMessageError(message: string) {
    this.snackbar.message = message
    this.snackbar.show = true
    this.solicitacaoStore.setSnackbar(this.snackbar)
  }

  @Emit('setLoadingRequest')
  setLoadingRequest(status, text) {}

  @Emit('clearLoadingRequest')
  clearLoadingRequest() {}

  @Watch('showItensAutorizadosClinica')
  async onCloseOpen() {
    if (this.showItensAutorizadosClinica) {
      const res = await this.solicitacaoClinicaStore.getAnexosOperadora(this.solicitacao.id)
      this.anexosOperadora = res.data!
    } else {
      this.anexosOperadora = []
      this.anexosToUpload = []
      this.anexosToDelete = []
    }
  }
}

interface AnexoOperadora extends Laudo {
  queueIndex?: number
}
